import useClientConfig from "../../../../../config/careers/clientConfig";
import React from "react";

const AnglisseduBanner = () => {
    const { clientAssetsLink } = useClientConfig();

    return (
        <>
            <div id="careers" className="home__careers">
                <div className="angliss">
                    <img src={clientAssetsLink + "/william-angliss-institute-melbourne-campus-reception.jpg"} alt="Banner" className="banner-img" />
                    <div className="banner-overlay">
                        <h2>Angliss Careers</h2>
                        <p className="subtitle">Join the Journey of Passion and Fulfilment</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AnglisseduBanner;